export class ApiUrls {
    // ReSharper disable InconsistentNaming
    public static readonly ErrorUrl: string = '/api/error/ui';

    public static readonly RootUrl: string = '/api';
    public static readonly PersonUrl: string = '/api/person';
    public static readonly PersonRevalidateUrl: string = '/api/person/revalidate';
    public static readonly PersonPublishUrl: string = '/api/person/publish';
    public static readonly PersonLookupUrl: string = '/api/person/lookup';
    public static readonly PersonLookupByPhoneUrl: string = '/api/person/lookup-by-phone';
    public static readonly PersonByIdUrl: string = '/api/person/info';
    public static readonly RelatedPersonUrl: string = '/api/person/related-person';
    public static readonly PersonSmsUrl: string = '/api/person/sms';
    public static readonly PersonSmsCrewUrl: string = '/api/person/sms-crew';
    public static readonly IsConstantFreelancerUrl: string = '/api/personrequest/is-constant-freelancer';
    public static readonly HasTzvContract: string = '/api/personrequesttzv/has-tzv-contract';
    public static readonly PersonLicensesUrl: string = '/api/person/licenses';
    public static readonly PersonMintLicensesUrl: string = '/api/person/mint-licenses';
    public static readonly PersonMintLicenseInactivationsUrl: string = '/api/person/mint-license-inactivations';
    public static readonly PersonPlanningFunctionOverrulesUrl: string = '/api/person/planning-function-overrules';
    public static readonly PersonAircraftActivitiesUrl: string = '/api/person/aircraft-activities';
    public static readonly PersonAirportsUrl: string = '/api/person/airports';
    public static readonly PersonShowMySchedule: string = '/api/person/show-my-schedule';
    public static readonly PersonShowMyPhone: string = '/api/person/show-my-phone';
    public static readonly PersonOptInShowEfaSchedule: string = '/api/person/opt-in-show-efa-schedule';
    public static readonly PersonOptInShowAeropersSchedule: string = '/api/person/opt-in-show-aeropers-schedule';
    public static readonly PersonEntriesUrl: string = '/api/person/entries';
    public static readonly PersonFunctionsUrl: string = '/api/person/functions';
    public static readonly PersonModificationsUrl: string = '/api/person/person-modifications';

    public static readonly PersonInfoUrl: string = '/api/personinfo';
    public static readonly PersonQuarterInfoUrl: string = '/api/personinfo/quarter';
    public static readonly PersonSummaryInfoUrl: string = '/api/personinfo/summary-figures';
    public static readonly PersonDeltaInfoUrl: string = '/api/personinfo/delta-figures';
    public static readonly PersonConsecutiveMonthInfoUrl: string = '/api/personinfo/consecutive3month-figures';
    public static readonly PersonDutyPeriodInfoUrl: string = '/api/personinfo/duty-periods';
    public static readonly PersonDayDutyFiguresUrl: string = '/api/personinfo/duty-figures';
    public static readonly PersonDayDayStatusUrl: string = '/api/personinfo/day-status';
    public static readonly PersonDatePopupDataUrl: string = '/api/personinfo/popup-data';
    public static readonly ChangeCheckInCheckOutUrl: string = '/api/personinfo/cico/change';
    public static readonly ResetCheckInCheckOutUrl: string = '/api/personinfo/cico/reset';
    public static readonly CiCoSetByEstimated: string = '/api/personinfo/cico/set-by-estimated';
    public static readonly CheckInCheckOutInfoUrl: string = '/api/personinfo/cico/';
    public static readonly PersonLocation: string = '/api/personinfo/location';

    public static readonly AirportsUrl: string = '/api/airport';

    public static readonly HolidayUrl: string = '/api/holiday';

    public static readonly HomeStudyUrl: string = '/api/homestudy';
    public static readonly HomeStudyPersonsUrl: string = '/api/homestudy/persons';

    public static readonly FlightUrl: string = '/api/flight';
    public static readonly FlightSectorUrl: string = '/api/flight/sectors';
    public static readonly FlightInfoUrl: string = '/api/flight/info';
    public static readonly FlightHistoryUrl: string = '/api/flight/history';
    public static readonly FlightFdpExtensionUrl: string = '/api/flight/person-fdp-extension-type';
    public static readonly FlightFdpAmendmentTypeUrl: string = '/api/flight/person-fdp-amendment-type';
    public static readonly FlightDecodeUrl: string = '/api/flight/decode';
    public static readonly FlightCrewDetailsUrl: string = '/api/flight/crew-details';
    public static readonly FlightPublishUrl: string = '/api/flight/publish-netline';
    public static readonly FlightSectorByIdUrl: string = '/api/flight/sector';
    public static readonly UrgentFlightUrl: string = '/api/flight/urgent';
    public static readonly UrgentFlightSuppressUrl: string = '/api/flight/urgent-suppress';

    public static readonly RotationUrl: string = '/api/rotation/for-day';
    public static readonly LonghaulRotationUrl: string = '/api/rotation/long-haul';
    public static readonly LonghaulByIdUrl: string = '/api/rotation/long-haul/single';
    public static readonly LonghaulForPeriodUrl: string = '/api/rotation/long-haul/for-period';
    public static readonly RotationIdByKeyUrl: string = '/api/rotation/rotation-id';
    public static readonly RotationDirectionsUrl: string = '/api/rotation/directions';
    public static readonly RotationBuildUrl: string = '/api/rotation/build';
    public static readonly RotationPutUrl: string = '/api/rotation';
    public static readonly RotationCopyUrl: string = '/api/rotation/copy';
    public static readonly RotationCopyDatesUrl: string = '/api/rotation/dates';
    public static readonly RotationFlightDatesUrl: string = '/api/rotation/flight-dates';
    public static readonly RotationDeleteUrl: string = '/api/rotation/delete';
    public static readonly RotationAvailableFlightsUrl: string = '/api/rotation/available-flights';
    public static readonly RotationInitUrl: string = '/api/rotation/init-rotation';
    public static readonly RotationByIdUrl: string = '/api/rotation';
    public static readonly RotationsForFlightUrl: string = '/api/rotation/flight';
    public static readonly RotationAircraftUrl: string = '/api/rotation/aircraft';

    public static readonly AirbusTypesUrl: string = '/api/personlicense/airbus-types';
    public static readonly ContractTypeUrl: string = '/api/contract/types';
    public static readonly ContractFlagTypeUrl: string = '/api/contract/flag-types';

    public static readonly TypeRatingFiltersUrl: string = '/api/typeratingfilter';
    public static readonly InstructorFiltersUrl: string = '/api/instructorfilter';

    public static readonly ReleaseHistoryUrl: string = '/api/releasehistory/release';
    public static readonly ReleaseHistoryAvailableMonthsUrl: string = '/api/releasehistory/available-months';
    public static readonly ReleaseHistoryPersonsWithNotFullDutyMonthUrl: string = '/api/releasehistory/not-full-persons';
    public static readonly ReleaseHistoryDateUrl: string = '/api/releasehistory/release-date';
    public static readonly ReleaseHistoryGroupsUrl: string = '/api/releasehistory/release-groups';
    public static readonly ReleaseHistoryPeriodsUrl: string = '/api/releasehistory/release-periods';
    public static readonly ReleaseHistoryStatusUrl: string = '/api/releasehistory/release-status';

    public static readonly LlmLikeUrl: string = '/api/llmoperation/like';
    public static readonly LlmDislikeUrl: string = '/api/llmoperation/dislike';

    public static readonly DutyValidationDataUrl: string = '/api/duty/validation-data';
    public static readonly DutyValidationGroundDataUrl: string = '/api/duty/validation-data-ground';
    public static readonly DutyValidationFseDataUrl: string = '/api/duty/validation-data-fse';
    public static readonly DutyDownloadValidationUrl: string = '/api/duty/download-validation';
    public static readonly DutyDownloadValidationResultUrl: string = '/api/duty/download-validation-result';
    public static readonly DutyUndoUrl: string = '/api/duty/undo';
    public static readonly DutyRollbackUndoUrl: string = '/api/duty/rollback-undo';
    public static readonly DutySwapUrl: string = '/api/duty/swap';
    public static readonly DutyHideUrl: string = '/api/duty/hide-duty';
    public static readonly DutyUpdateTitleUrl: string = '/api/duty/update-title';
    public static readonly DutyCopyUrl: string = '/api/duty/copy';
    public static readonly DutyPersistShadowDuties: string = '/api/duty/persist';
    public static readonly DayActivitiesUrl: string = 'api/duty/day-activities';
    public static readonly MonthDutyTypeUrl: string = '/api/duty/month-duty-types';
    public static readonly ReleaseFilterTypeUrl: string = '/api/duty/release-filter-types';
    public static readonly PopToolDutyHistory: string = '/api/duty/history';
    public static readonly PartialLoadTypeUrl: string = '/api/duty/partial-load-types';
    public static readonly GetDutyHoursUrl: string = '/api/duty/get-duty-hours';
    public static readonly ChangeDutyHoursUrl: string = '/api/duty/change-duty-hours';
    public static readonly UrgentDutyUrl: string = '/api/duty/urgent';
    public static readonly UrgentDutyRPUrl: string = '/api/duty/urgent-release-period';
    public static readonly PersonDayLandingUrl: string = '/api/duty/person-day-landing';
    public static readonly SeatHistory: string = '/api/duty/seat-history';
    public static readonly DutyHidePlanningPeriodUrl: string = '/api/duty/configure-planning-period';
    public static readonly DutyGetPlanningPeriodsUrl: string = '/api/duty/planning-periods';
    public static readonly DutyPartUrl: string = '/api/duty/duty-part';
    public static readonly DutyRecencyLandings: string = '/api/duty/recency-landings';
    public static readonly DutyRecencyTakeoffs: string = '/api/duty/recency-takeoffs';

    public static readonly PlanningDutyPeriodUrl: string = '/api/duty/planning-duty-period';
    public static readonly PlanningDutyPeriodStartUrl: string = '/api/duty/planning-duty-period-start';
    public static readonly PlanningDutyPeriodReleaseUrl: string = '/api/duty/planning-duty-period-release';

    public static readonly PersonDayMessageHistoryUrl: string = '/api/duty/person-day-messages';
    public static readonly FlightMessageHistoryUrl: string = '/api/flight/messages';
    public static readonly PersonMessageHistoryUrl: string = '/api/person/messages';

    public static readonly DutySectorSwapCrewUrl: string = '/api/duty/sector/swap-crew';
    public static readonly DutySectorMoveCrewUrl: string = '/api/duty/sector/move-crew';
    public static readonly DutyRotationSwapCrewUrl: string = '/api/duty/rotation/swap-crew';
    public static readonly DutyRotationMoveCrewUrl: string = '/api/duty/rotation/move-crew';

    public static readonly JeppesenExportedFileListUrl: string = '/api/jeppesentool/list';
    public static readonly JeppesenRosterExportInfoUrl: string = '/api/jeppesentool/roster-export-info';
    public static readonly JeppesenCrewExportInfoUrl: string = '/api/jeppesentool/crew-export-info';
    public static readonly JeppesenRosterImportInfoUrl: string = '/api/jeppesentool/roster-import-info';
    public static readonly JeppesenDownloadFileUrl: string = '/api/jeppesentool/download-file';
    public static readonly JeppesenRosterImportsUrl: string = '/api/jeppesentool/roster-imports';
    public static readonly JeppesenRosterImportDetailsUrl: string = '/api/jeppesentool/roster-import-details';
    public static readonly JeppesenRosterImportExceptionUrl: string = '/api/jeppesentool/roster-import-exception';
    public static readonly JeppesenRosterImportFileDataUrl: string = '/api/jeppesentool/roster-import-file-data';
    public static readonly JeppesenRosterImportUploadFileUrl: string = '/api/jeppesentool/roster-import-upload-file';
    public static readonly JeppesenCasImportInfoUrl: string = '/api/jeppesentool/cas-import-info';
    public static readonly JeppesenCasImportFileUrl: string = '/api/jeppesentool/cas-import-file';

    public static readonly TradeUnionExportInfoUrl: string = '/api/tradeunioninterface/export-info';
    public static readonly TradeUnionDownloadFileUrl: string = '/api/tradeunioninterface/download-file';
    public static readonly TradeUnionExportsUrl: string = '/api/tradeunioninterface/exports';
    public static readonly TradeUnionExportsFileDataUrl: string = '/api/tradeunioninterface/file-data';

    public static readonly CateringReportDataUrl: string = '/api/cateringreport';
    public static readonly GroundStaffReportUrl: string = '/api/groundstaffreport';

    public static readonly DutyValidationUrl: string = '/api/dutyvalidation';
    public static readonly DutyValidationUrgentUrl: string = '/api/dutyvalidation/urgent';
    public static readonly DutyValidationSuppressReasonsUrl: string = '/api/dutyvalidation/suppress-reasons';
    public static readonly DutyValidationSuppressUrl: string = '/api/dutyvalidation/suppress';
    public static readonly DutyValidationResumeUrl: string = '/api/dutyvalidation/resume';
    public static readonly DutyValidationSuppressErrorsUrl: string = '/api/dutyvalidation/suppress-errors';
    public static readonly DutyValidationErrorsInfoUrl: string = '/api/dutyvalidation/errors-info';
    public static readonly DutyValidationExplainModelsUrl: string = '/api/dutyvalidation/explain-models';

    public static readonly DutyDayUrl: string = '/api/duty/day-duties';

    public static readonly DutyCheckerTraineeUrl: string = '/api/dutycheckertrainee';
    public static readonly DutyCheckerTraineePersonUrl: string = '/api/dutycheckertrainee/person';
    public static readonly DutyCheckerTraineeFunctionUrl: string = '/api/dutycheckertrainee/function';
    public static readonly DutyCheckerTraineeLongHaulUrl: string = '/api/dutycheckertrainee/long-haul';
    public static readonly DutyCheckerTraineeFlightTeamUrl: string = '/api/dutycheckertrainee/flight-team';
    public static readonly DutyCheckerTraineeGroundTeamUrl: string = '/api/dutycheckertrainee/ground-team';

    public static readonly FunctionUrl: string = '/api/function';
    public static readonly FunctionGroupUrl: string = '/api/function/group';

    public static readonly SimulationUrl: string = '/api/simulation';
    public static readonly SimulationPlannedUrl: string = '/api/simulation/activity/planned';
    public static readonly SimulationTraineeCandidatesUrl: string = '/api/simulation/trainee-candidates';
    public static readonly SimulationHistoryUrl: string = '/api/simulation/history';
    public static readonly SimulationDeletionHistoryUrl: string = '/api/simulation/deletion-history';
    public static readonly SimulationPositionHistoryUrl: string = '/api/simulation/position-history';
    public static readonly SimulationPositionLogHistoryUrl: string = '/api/simulation/position-history-log';

    public static readonly ConfigurationUrl: string = '/api/configuration';
    public static readonly MaintenanceUrl: string = '/api/maintenance';
    public static readonly MaintenanceNotificationUrl: string = '/api/maintenance/notification';
    public static readonly VersionUrl: string = '/api/dev/version';

    public static readonly ServiceRevalidateAllUrl: string = '/api/service/revalidate-all';
    public static readonly ServicePersonValidationUrl: string = '/api/service/person-validation';
    public static readonly ServiceRecalculateExperienceUrl: string = '/api/service/recalculate-experience';
    public static readonly ServiceDownloadFullLogsUrl: string = '/api/service/download-full-logs';
    public static readonly ServiceDownloadDayLogsUrl: string = '/api/service/download-day-logs';
    public static readonly ServiceDownloadMessagesUrl: string = '/api/service/download-messages';
    public static readonly ServiceDownloadDeadlettersUrl: string = '/api/service/download-deadletters';
    public static readonly ServiceDatesWithLogsUrl: string = '/api/service/logs-dates';
    public static readonly ServiceMessagesDatesUrl: string = '/api/service/messages-dates';
    public static readonly ServiceMessagesLabelsUrl: string = '/api/service/message-labels';
    public static readonly ServiceMessagesTagsUrl: string = '/api/service/message-tags';
    public static readonly ServiceVacationDataCalculationUrl: string = '/api/service/vacation-calculation';
    public static readonly MessageStatisticsUrl: string = '/api/service/message-statistics';
    public static readonly ServiceQueueStatisticsUrl: string = '/api/service/input-queue-statistics';
    public static readonly ServiceQueueDeadlettersUrl: string = '/api/service/input-queue-deadletters';
    public static readonly ServiceRestartSchedulerUrl: string = '/api/service/restart-scheduler';
    public static readonly ServiceOperationsUrl: string = '/api/service/operations';

    public static readonly PushNotificationKeyUrl: string = '/api/pushnotification/notification-key';
    public static readonly PushNotificationEnableUrl: string = '/api/pushnotification/notification-enable';
    public static readonly PushNotificationDisableUrl: string = '/api/pushnotification/notification-disable';
    public static readonly PushNotificationHasSubscriptionUrl: string = '/api/pushnotification/has-subscription';

    public static readonly LocalToUtc: string = '/api/time/local-to-utc';
    public static readonly UtcToLocal: string = '/api/time/utc-to-local';
    public static readonly AvailableTimeZones: string = '/api/time/available-timezones';
    public static readonly TimezoneOffsets: string = '/api/time/timezone-offsets';
    public static readonly DefaultTimezoneOffset: string = '/api/time/default-timezone';
    public static readonly TimeSwissTransitions: string = '/api/time/swiss-transitions';

    public static readonly ChangeLogUrl: string = '/api/changeLog';
    public static readonly ChangeLogSetPlanningConfirmationUrl: string = '/api/changeLog/set-planning-confirmation';
    public static readonly ChangeLogUpdateReasonUrl: string = '/api/changeLog/reason';
    public static readonly ChangeLogUpdateOldDutyTextUrl: string = '/api/changeLog/oldDutyText';
    public static readonly ChangeLogUpdateNewDutyTextUrl: string = '/api/changeLog/newDutyText';

    public static readonly CrewDutyListReportUrl: string = '/api/crewdutylistreport';
    public static readonly CrewApiConfigReportUrl: string = '/api/crewapi/config-report';
    public static readonly PersonReportUrl: string = '/api/personsreport';
    public static readonly RecurrentTrainingReportUrl: string = '/api/recurrenttrainingreport';
    public static readonly SectorsReportUrl: string = '/api/sectorsreport';
    public static readonly SimulatorLicenseStatusReportUrl: string = '/api/simulatorlicensestatusreport';
    public static readonly StandbyReportUrl: string = '/api/standbyreport';
    public static readonly StandbyReportPersonFunctionsUrl: string = '/api/standbyreport/functions';
    public static readonly StandbyReportCreateEmailUrl: string = '/api/standbyreport/download-email';
    public static readonly PlannedTrainingsReportUrl: string = '/api/plannedtrainingsreport';
    public static readonly AirportRecencyReportUrl: string = '/api/airportrecencyreport';
    public static readonly AreaRouteCompetenceReportUrl: string = '/api/arearoutecompetencereport';
    public static readonly AreaRouteCompetenceRulesUrl: string = '/api/arearoutecompetence/rules-report';
    public static readonly CommentReportUrl: string = '/api/commentreport';
    public static readonly AbsenceReportUrl: string = '/api/absencereport';
    public static readonly OffDaysReportUrl: string = '/api/offdaysreport';
    public static readonly AircraftTypeRecencyReportUrl: string = '/api/aircrafttyperecencyreport/cabin';
    public static readonly AircraftTypeRecencyCockpitReportUrl: string = '/api/aircrafttyperecencyreport/cockpit';
    public static readonly DooxReportUrl: string = '/api/dooxreport';
    public static readonly ExperienceReportUrl: string = '/api/experiencereport';
    public static readonly ErrorReportUrl: string = '/api/errorreport';
    public static readonly XStarMonitoringReportUrl: string = '/api/xstarmonitoringreport';
    public static readonly DosimetryReportUrl: string = '/api/dosimetryreport';
    public static readonly SeniorityReportUrl: string = '/api/seniorityreport';
    public static readonly SimulationReportUrl: string = '/api/Simulation';
    public static readonly CrewNotificationTimeReportUrl: string = '/api/crewnotificationtime';

    public static readonly LogbookUrl: string = '/api/logbook';

    public static readonly HotelManagementLocationUrl: string = '/api/hotelmanagement/locations';
    public static readonly HotelManagementLocationMonthUrl: string = '/api/hotelmanagement/locations-month';
    public static readonly HotelManagementHotelDetailsUrl: string = '/api/hotelmanagement/hotel-details';
    public static readonly HotelManagementHotelPersonDetailsUrl: string = '/api/hotelmanagement/hotel-person-details';
    public static readonly HotelManagementPreReservationDetailsUrl: string = '/api/hotelmanagement/pre-reservation/hotel-details';
    public static readonly HotelManagementPreReservationBookingDetailsUrl: string = '/api/hotelmanagement/pre-reservation/hotel-booking-details';
    public static readonly HotelManagementCreateEmailUrl: string = '/api/hotelmanagement/download-email';
    public static readonly HotelManagementCreatePreReservationEmailUrl: string = '/api/hotelmanagement/pre-reservation/download-email';

    public static readonly AircraftsUrl: string = '/api/aircraft';
    public static readonly AircraftTypeUrl: string = '/api/aircraft/type';
    public static readonly AircraftTypeGroupUrl: string = '/api/aircraft/type-group';
    public static readonly AircraftsMaintenanceUrl: string = '/api/aircraft/maintenance';

    public static readonly RequestToolOffUrl: string = '/api/personrequest/off';
    public static readonly RequestToolAllRequests: string = '/api/personrequest/requests';
    public static readonly RequestToolPoints: string = '/api/personrequest/points-balance';
    public static readonly RequestToolPointsLog: string = '/api/personrequest/points-log';
    public static readonly RequestToolPointsPeriods: string = '/api/personrequest/points-periods';
    public static readonly RequestToolPointsManualCorrection: string = '/api/personrequest/manual-correction';
    public static readonly RequestToolAvailableFlights: string = '/api/personrequest/available-flights';
    public static readonly RequestToolPersonFlights: string = '/api/personrequest/flight';
    public static readonly RequestToolGrantJobStatus: string = '/api/personrequest/grant-job-status';
    public static readonly RequestToolRejectFlight: string = '/api/personrequest/flight/rejected-by-planner';
    public static readonly RequestToolPersonFlightsOffs: string = '/api/personrequest/rotation-offs';
    public static readonly RequestToolValidateOff: string = '/api/personrequest/validate-off';
    public static readonly RequestToolPersonInfo: string = '/api/personrequest/person-info';
    public static readonly RequestToolResolveRequest: string = '/api/personrequest/resolve';
    public static readonly RequestToolRotation: string = 'api/personrequest/rotation-days';
    public static readonly RequestToolAvailableRequestRange: string = '/api/personrequest/available-request-range';
    public static readonly RequestToolOffLimits: string = '/api/personrequest/off-limits';
    public static readonly RequestToolFlightLimitsCockpit: string = '/api/personrequest/flight-limits-cockpit';
    public static readonly RequestToolFlightLimitsCabin: string = '/api/personrequest/flight-limits-cabin';
    public static readonly RequestToolFlightLimitsLogsForCabin: string = '/api/personrequest/flight-limits-logs-cabin';
    public static readonly RequestToolFlightLimitsLogsForCockpit: string = '/api/personrequest/flight-limits-logs-cockpit';
    public static readonly RequestToolShortTypeRatingLicenses: string = '/api/personrequest/short-tr-licenses';
    public static readonly PersonRequestBlockingDay: string = '/api/personrequestblockingperiod/day';
    public static readonly PersonRequestBlockingFlight: string = '/api/personrequestblockingflight/flight';

    public static readonly RequestToolVacation: string = '/api/personrequestvac';
    public static readonly RequestToolVacationValidate: string = '/api/personrequestvac/validation';
    public static readonly RequestToolVacationRequestRules: string = '/api/personrequestvac/rules-status';
    public static readonly RequestToolAvailiableVacTypes: string = '/api/personrequestvac/available-types';
    public static readonly RequestToolVacationDaysBalanceInfo: string = '/api/personrequestvac/balance-info';
    public static readonly RequestToolVacationDaysBalanceTotal: string = '/api/personrequestvac/balance-info/total';
    public static readonly RequestToolVacationDaysManualCorrection: string = '/api/personrequestvac/balance/manual-correction';
    public static readonly RequestToolVacationYearPeriods: string = '/api/personrequestvac/vacation-periods';
    public static readonly RequestToolVacationYears: string = '/api/personrequestvac/vacation-years';
    public static readonly RequestToolVacationAvailiableVacSDaysAndDeadline: string = '/api/personrequestvac/vac-s-deadline-info';
    public static readonly RequestToolVacationAvailiableVacPDaysAndDeadline: string = '/api/personrequestvac/vac-p-deadline-info';
    public static readonly RequestToolVacRequestBlock: string = '/api/personrequestvac/request-block';
    public static readonly RequestToolVacationAbsence: string = '/api/personrequestvac/vac-blocks';

    public static readonly RequestToolTzvYears: string = '/api/personrequesttzv/tzv-years';
    public static readonly RequestToolTzvBalanceInfo: string = '/api/personrequesttzv/tzv-balance-info';
    public static readonly RequestToolTzvBalanceTotal: string = '/api/personrequesttzv/tzv-balance-info/total';
    public static readonly RequestToolTzvBlocks: string = '/api/personrequesttzv/tzv-blocks';
    public static readonly RequestToolTzvManualCorrection: string = '/api/personrequesttzv/balance/manual-correction';
    public static readonly RequestToolTzvContractInfo: string = '/api/personrequesttzv/contract-info';
    public static readonly RequestToolTzvAssignment: string = '/api/personrequesttzv/tzv-assignment';
    public static readonly RequestToolTzvFlex: string = '/api/personrequesttzv/tzv-flex';

    public static readonly RequestToolFlightDutyRecord: string = '/api/flightdutyrecord';
    public static readonly RequestToolFlightDutyRecordDownload: string = '/api/flightdutyrecord/Download';
    public static readonly RequestToolLogbookDownload: string = '/api/logbook/Download';

    public static readonly RequestToolNbu: string = '/api/personrequestnbu';

    public static readonly RequestPersonView: string = '/api/personview';
    public static readonly RequestPersonCabinRecency: string = '/api/personview/cabin-recency';
    public static readonly RequestPersonCockpitRecency: string = '/api/personview/cockpit-recency';

    public static readonly TzvYearOverviewReport: string = '/api/tzvyearoverviewreport';
    public static readonly TzvYearOverviewYears: string = '/api/tzvyearoverviewreport/tzv-years';
    public static readonly TzvYearOverviewFleetTypes: string = '/api/tzvyearoverviewreport/fleet-types';

    public static readonly VacManagement: string = '/api/vacmanagement/requests';
    public static readonly VacManagementRequestBlock: string = '/api/vacmanagement/request-block';
    public static readonly VacManagementValidateSelectedRange: string = '/api/vacmanagement/selected-range-validation';
    public static readonly VacManagementUpdateSelectedRange: string = '/api/vacmanagement/update-selected-range';
    public static readonly VacManagementVacYears: string = '/api/vacmanagement/vacation-years';
    public static readonly VacManagementVacYearPeriods: string = '/api/vacmanagement/vacation-year-periods';
    public static readonly VacManagementVacYearPeriodsFilterOptions: string = '/api/vacmanagement/vacation-year-periods-filter-options';
    public static readonly VacManagementVacYearPeriodModels: string = '/api/vacmanagement/vacation-periods';
    public static readonly VacManagementInform: string = '/api/vacmanagement/inform';
    public static readonly VacManagementCapacityFigures: string = '/api/vacmanagement/capacity-figures';
    public static readonly VacManagementCapacityMonthFigures: string = '/api/vacmanagement/capacity-month-figures';
    public static readonly VacManagementVacTypes: string = '/api/vacmanagement/vac-types';
    public static readonly VacManagementMonthFromOptions: string = '/api/vacmanagement/month-from-options';
    public static readonly VacManagementMonthToOptions: string = '/api/vacmanagement/month-to-options';
    public static readonly VacManagementPersonVacYearDetails: string = '/api/vacmanagement/person-vac-year-details';

    public static readonly ReserveManagement: string = '/api/reservemanagement/requests';
    public static readonly ReserveBlocksManagement: string = '/api/reservemanagement/reserve-blocks';
    public static readonly ReserveBlockImport: string = '/api/reservemanagement/import';
    public static readonly RequestToolReserveDutyBlocks: string = '/api/personrequestreserve/reserve-duty-blocks';

    public static readonly CommentUrl: string = '/api/comment/';
    public static readonly PersonCommentUrl: string = '/api/comment/person';
    public static readonly PersonUpdateOnlyCommentUrl: string = '/api/comment/person-update-comment';
    public static readonly DayCommentUrl: string = '/api/comment/day';
    public static readonly CreateMultiDayCommentUrl: string = '/api/comment/create-multi';
    public static readonly FlightCommentUrl: string = '/api/comment/flight';
    public static readonly AcceptValidationErrorCommentUrl: string = '/api/comment/validation';
    public static readonly DutyCommentUrl: string = '/api/comment/duty';
    public static readonly NoteCommentUrl: string = '/api/comment/planning-note';
    public static readonly CommentStandbyUrl: string = '/api/comment/standby';

    public static readonly JobUrl: string = '/api/job/';

    public static readonly JobList: string = '/api/job/list';
    public static readonly JobStartUrl: string = '/api/job/start';
    public static readonly JobStopUrl: string = '/api/job/stop';
    public static readonly JobParametersUrl: string = '/api/job/parameters';
    public static readonly JobSettingsUrl: string = '/api/job/settings';
    public static readonly JobCronValidation: string = '/api/Job/cron/validation';
    public static readonly JobTriggerCreateUrl: string = '/api/job/create';
    public static readonly JobTriggerDeleteUrl: string = '/api/job/delete';
    public static readonly CheckTriggerNameUrl: string = '/api/job/check-trigger-name';

    public static readonly MonitoringUrl: string = '/api/monitoring';

    public static readonly SelfTestJobsUrl: string = '/api/selftest/jobs';
    public static readonly SelfTestDatabaseUrl: string = '/api/selftest/database';
    public static readonly SelfTestSignalRUrl: string = '/api/selftest/signalr';
    public static readonly SelfTestPersonDayQueueUrl: string = '/api/selftest/persondayqueue';
    public static readonly SelfTestPersonRevalidateUrl: string = '/api/selftest/personrevalidate';
    public static readonly SelfTestEmailQueueUrl: string = '/api/selftest/emailqueue';
    public static readonly SelfTestNetlineOpsQueue: string = '/api/selftest/netline-ops-queue';
    public static readonly SelfTestPersonMessageBusQueue: string = '/api/selftest/person-message-bus-queue';
    public static readonly SelfTestCrewApiQueue: string = '/api/selftest/crew-api-queue';
    public static readonly SelfTestCrewApiMclQueue: string = '/api/selftest/crew-api-mcl-queue';

    public static readonly OnlinePrincipalConnectedClientsUrl: string = '/api/onlineprincipal/connected-clients';
    public static readonly OnlinePrincipalRosterActiveityUrl: string = '/api/onlineprincipal/roster-activity';

    public static readonly PlanningFlightActivityCandidatesUrl: string = '/api/planning/flight-activity-candidates';
    public static readonly PlanningValidateFlightActivityCandidateUrl: string = '/api/planning/validate-flight-candidate';
    public static readonly PlanningDutyRestTime: string = '/api/planning/rest-delta-times';
    public static readonly PlanningORTools: string = '/api/planning/ortools';

    public static readonly PermissionUrl: string = '/api/permission';
    public static readonly PermissionRoleUrl: string = '/api/permission/role';

    public static readonly PersonChangeLog: string = '/api/personchangelog';
    public static readonly PersonChangeLogConfirm: string = '/api/personchangelog/confirm';
    public static readonly PersonChangeLogLast: string = '/api/personchangelog/last';

    public static readonly RequestCapacityToolAnalyze: string = '/api/requestcapacitytool/analyze';
    public static readonly RequestCapacityToolImport: string = '/api/requestcapacitytool/import';
    public static readonly RequestCapacityToolOverview: string = '/api/requestcapacitytool/overview';
    public static readonly RequestCapacityToolFiles: string = '/api/requestcapacitytool/files';
    public static readonly RequestCapacityToolDownload: string = '/api/requestcapacitytool/download';

    public static readonly CalendarMonthUrl: string = '/api/time/calendar-month';

    public static readonly LicenseManagementUrl: string = '/api/licensemanagement/license-list';

    public static readonly CourseManagementUrl: string = '/api/coursemanagement/list';
    public static readonly CabinCrewAttestationUrl: string = '/api/coursemanagement/report';
    public static readonly CabinCrewAttestationPdfUrl: string = '/api/coursemanagement/export-pdf';
    public static readonly CabinCrewAttestationBazlUrl: string = '/api/coursemanagement/export-bazl';
    public static readonly CabinCrewAttestationPersonPdfUrl: string = '/api/coursemanagement/person-export-pdf';
    public static readonly CourseManagementImport: string = '/api/coursemanagement/import';

    public static readonly CustomPersonManagementUrl: string = '/api/custompersonmanagement/list';

    public static readonly CrewApiPayload: string = '/api/crewapi/payload';
    public static readonly CrewApiHistory: string = '/api/crewapi/history';
    public static readonly CrewApiGenerate: string = '/api/crewapi/generate';
    public static readonly CrewApiProcess: string = '/api/crewapi/process';
    public static readonly CrewApiRelatedAirports: string = '/api/crewapi/related-airports';
    public static readonly CrewApiFlightsStatus: string = '/api/crewapi/flight-status';
    public static readonly CrewApiPersonStatus: string = '/api/crewapi/person-status';
    public static readonly CrewApiPersonState: string = '/api/crewapi/person-state';
    public static readonly CrewApiAddMcl: string = '/api/crewapi/add-mcl';
    public static readonly CrewApiUpdateMcl: string = '/api/crewapi/update-mcl';
    public static readonly CrewApiDeleteMcl: string = '/api/crewapi/delete-mcl';
    public static readonly CrewApiSkipMcl: string = '/api/crewapi/skip-mcl';
    public static readonly CrewApiGetMclMissingDataPersons: string = '/api/crewapi/mcl-missing-data';
    public static readonly CrewApiMassConfiguration: string = '/api/crewapi/mass-configuration';

    public static readonly GenDecUrl: string = '/api/gendec';
    public static readonly GenDecRotationUrl: string = '/api/gendec/rotation';
    public static readonly GenDecRelatedAirports: string = '/api/gendec/related-airports';
    public static readonly GenDecFlightsStatus: string = '/api/gendec/flight-status';
    public static readonly GenDecProcess: string = '/api/gendec/process';
    public static readonly GenDecPayload: string = '/api/gendec/payload';
    public static readonly GenDecConfigReport: string = '/api/gendec/config-report';

    public static readonly TempFileUrl: string = '/api/tempfile';

    public static readonly TemplatesManagement = '/api/templatesmanagement';
    public static readonly TemplatesManagementCodes = '/api/templatesmanagement/codes';

    public static readonly EmailsUrl = '/api/email';
    public static readonly EmailBodyUrl = '/api/email/body';
    public static readonly EmailAttachmentsUrl = '/api/email/attachments';
    public static readonly EmailAttachmentDownloadUrl = '/api/email/attachment';
    public static readonly EmailUpdateStatusUrl = '/api/email/update-status';
    public static readonly EmailValidateUrl = '/api/email/validate';

    public static readonly PingUrl: string = '/api/dev/ping';

    public static readonly ReleaseNotesUrl: string = '/api/releasenotes';
    public static readonly ReleaseNotesMarkAsReadUrl: string = '/api/releasenotes/mark-as-read';

    public static readonly QualityLoopExportUrl: string = '/api/qualityloopexport';
    public static readonly QualityLoopExportDataUrl: string = '/api/qualityloopexport/data';
    public static readonly QualityLoopExportMappingUrl: string = '/api/qualityloopexport/id-mapping';
}
